"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORIENTATIONS = void 0;
var ORIENTATIONS = Object.freeze({
  horizontal: 'horizontal',
  vertical: 'vertical'
});
exports.ORIENTATIONS = ORIENTATIONS;